
import printJS from "print-js";

export default async function usePrintJS(initialData) {
    const bgUrl1 = new URL('@/assets/images/report-t.png', import.meta.url).href
    const bgUrl2 = new URL('@/assets/images/report-b.png', import.meta.url).href
    const bgUrl3 = new URL('@/assets/images/report-rt.png', import.meta.url).href
    const bgUrl4 = new URL('@/assets/images/report-lb.png', import.meta.url).href
    
    const images = [bgUrl1, bgUrl2, bgUrl3, bgUrl4].map(url => {
        const img = new Image();
        img.src = url;
        return new Promise((resolve) => {
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
        });
    });
    Promise.all(images).then((res) => {
        console.log(res);
        
        printJS({
            printable: "export-area",
            type: "html",
            maxWidth: "794px", // A4标准像素宽度
            scanStyles: false,
            style: `
                @page {
                    size: A4;
                }
                * {
                    box-sizing: border-box !important;
                    -webkit-print-color-adjust: exact !important;
                    color-adjust: exact !important;
                }
                .page-break {
                    page-break-after: always; 
                    break-after: always;
                    page-break-inside: avoid;
                }
                body {
                    margin: 0 !important;
                    padding: 0 !important;
                    width: 100vw;
                    height: 100vh;
                }
                .printBox {
                    width: 210mm !important;
                    height: 297mm !important;
                    margin: 0 auto !important;
                    overflow: hidden;
                    page-break-inside: avoid;
                }
                
                .common{
                    position: relative;
                }
                .common .bg-t{
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 231px;
                    height: 338px;
                    background-image: url("${bgUrl3}") !important;
                    background-repeat: no-repeat !important;
                    background-size: 100% 100%;
                }
                .common .bg-b{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 231px;
                    height: 338px;
                    background-image: url("${bgUrl4}") !important;
                    background-repeat: no-repeat !important;
                    background-size: 100% 100%;
                }
    
                .page1{
                    display: grid;
                    grid-template-rows: repeat(3, 1fr);
                }
                .page1 .bottom{
                    text-align: center;
                    margin-top: auto;
                    color: #0769CB;
                }
                .page1 .top{
                    width: 100%;
                    min-height: 200px;
                    background-image: url("${bgUrl1}") !important;
                    background-repeat: no-repeat !important;
                    background-size: 100% 200px;
                }
                .page1 .bottom{
                    width: 100%;
                    min-height: 200px;
                    background-image: url("${bgUrl2}") !important;
                    background-repeat: no-repeat !important;
                    background-size: 100% 200px;
                }
    
                .page2 .title{
                    font-size: 32px;
                    color: #0066CC;
                }
                .page2 .text{
                    font-size: 16px;
                    color: #333;
                }
                .page2 .text p{
                    text-indent: 2em;
                    line-height: 2;
                }
                .page2 .value{
                    display: inline-block;
                    background-color: #E9F1FF;
                    color: #0066CC;
                    text-indent: 0;
                    line-height: normal;
                    border-radius: 4px;
                    font-size: 21px;
                    padding: 4px 6px;
                    min-width: 50px;
                }
                .page2 .content{
                    padding: 80px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }
    
                .page3 .title{
                    font-size: 24px;
                    color: #0066CC;
                }
                .page3 .content{
                    padding: 40px;
                    height: 100%;
                }
                .page3 .chart-content{
                    padding: 20px;
                    height: 100%;
                    display: grid;
                    grid-template-rows: repeat(3,1fr);
                }
                .page3 .chartBox{
                    display: grid;
                    grid-template-rows: auto 1fr;
                }
    
                .page4 .title{
                    font-size: 32px;
                    color: #000;
                }
                .page4 .content{
                    padding: 40px;
                    height: 100%;
                    display: grid;
                    grid-template-rows: auto 1fr;
                }
                .page4 .chart-content{
                    padding: 20px;
                    display: grid;
                    grid-template-rows: repeat(2,1fr);
                }
                .page4 .chartBox{
                    display: grid;
                    grid-template-rows: auto 1fr;
                }
    
                .page5 .content{
                    padding: 40px;
                    height: 100%;
                }
                .page5 .chart-content{
                    padding: 20px;
                    height: 100%;
                    display: grid;
                    grid-template-rows: 40% 60%;
                }
                .page5 .chartBox{
                    display: grid;
                    grid-template-rows: auto 1fr;
                }
    
                .page6 .title{
                    font-size: 21px;
                    color: #000;
                }
                .page6 .text{
                    font-size: 16px;
                    color: #333;
                }
                .page6 .text p{
                    text-indent: 2em;
                    line-height: 2;
                    margin: 0;
                }
                .page6 .content{
                    padding: 80px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .page7 .title{
                    font-size: 21px;
                    color: #000;
                }
                .page7 .text{
                    font-size: 16px;
                    color: #333;
                }
                .page7 .text p{
                    text-indent: 2em;
                    line-height: 2;
                    margin: 0;
                }
                .page7 .content{
                    padding: 80px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 40px;
                }

                .page8 .title{
                    font-size: 21px;
                    color: #000;
                }
                .page8 .text{
                    font-size: 16px;
                    color: #333;
                }
                .page8 .text p{
                    text-indent: 2em;
                    line-height: 2;
                    margin: 0;
                }
                .page8 .content{
                    padding: 80px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 40px;
                }
            `,
        });
    })
    
}